export const CreateAccountPopupLabels = {
  title1: `Add Account`,
  title2: 'Add Project',
  submitButtonTitle: `Add`,
  addAccountButtonTitle: `+ Add New Account`,
  selectAccountDropdownTitle: 'Select an Account',
  // createAccountLabel: `*Create/ Select Account`,
  selectAccountLabel: `*Select Account`,
  addAccountLabel: `*Add Account`,
  selectProjectLabel: `Add Project`,
  addWbsCode: `WBS Code`,
  addAccountOwner: `Account Owner`,
  addOwnerEmail: `Account Owner Email`,
  addUseCase: `Usecase`,
  accountValidationMessage1: 'Please enter the account name.',
  accountValidationMessage2: 'Please select an account.',
  projectValidationMessage: 'Please enter an project name.',
  wbsValidationMessage: 'Please enter a WBS code.',
  accountOwnerValidationMessage: 'Please enter an account owner name.',
  accountOwnerEmailValidationMessage: 'Please enter an account owner email.',
  useCaseValidationMessage: 'Please enter an usecase.',
};
